import { Button } from "@mui/material"
import { store } from "../../../stores/Store"
import Field from "../../form/fields/Field"
import { Icons } from "../../../misc/Icons"
import InlineMenu from "../../../misc/InlineMenu"
import { Theme } from "../../../misc/Theme"
import React from "react"
import { DisplayDictionary } from "../../.."


export const ColumnHeaderAccount = ({label}) => {

    var options = store.NodeStore.accounts.map(account => {
        return {value: account.uid, label: account.label}
    })
    var filteringApplied = store.AutomationStore.searchAccountUids?.length < options?.length

    React.useEffect(() => {
        var allAccountUids = options.map(option => option.value)
        store.AutomationStore.setSearchAccountUids(allAccountUids)
    }, [])

    return (
        <InlineMenu 
            closeOnClick={false} 
            opener={(
                <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
                    <Button 
                        className="btn btn-lowercase" 
                        color="info">
                        {label}
                        {filteringApplied ? (
                            <span style={{height: "16px", lineHeight: "16px", fontSize: "10px", color: "white", backgroundColor: Theme.palette.error.main, padding: "0px 6px", borderRadius: "12px", fontWeight: 600}}>
                                {store.AutomationStore.searchAccountUids?.length}
                            </span>
                        ) : null}
                    </Button>
                    <Icons.ChevronLeft style={{fontSize: "18px", transform: "rotateZ(-90deg)"}} />
                </div>
            )}>

            <ColumnHeaderAccountField options={options} />
        </InlineMenu>
    )
}


const ColumnHeaderAccountField = ({options}) => {

    const { searchAccountUids, setSearchAccountUids } = store.AutomationStore

    return (
        <div style={{padding: "10px", width: "300px"}}>
            <div className="form">
                <h3>Filter by Sponsor</h3>
    
                <div style={{display: "grid", gap: "8px", maxHeight: "300px", overflowY: "auto", borderTop: "0.5px solid lightgrey", boxShadow: "#00000059 0px 14px 24px -16px inset", padding: "5px 0 0 5px"}}>
                    <Field.CheckboxSelect
                        formik 
                        value={searchAccountUids}
                        options={options}
                        warning={false}
                        onChange={(e) => setSearchAccountUids(e.target.value)} />
                </div>

                <div style={{display: "flex", gap: "5px"}}>
                    <Button className="btn btn-sm" variant="contained" onClick={() => store.AutomationStore.setSearchAccountUids([])}>Clear selection</Button>
                    <Button className="btn btn-sm" variant="contained" onClick={() => store.AutomationStore.setSearchAccountUids(options.map(option => option.value))}>Select all</Button>
                </div>
            </div>
        </div>
    )
}



export const ColumnHeaderStatus = ({label}) => {

    var options = DisplayDictionary("automation_status", true)
    var filteringApplied = store.AutomationStore.searchStatuses?.length < options?.length

    React.useEffect(() => {
        var allAccountUids = options.map(option => option.value)
        store.AutomationStore.setSearchStatuses(allAccountUids)
    }, [])

    return (
        <InlineMenu 
            closeOnClick={false} 
            opener={(
                <div style={{display: "flex", alignItems: "center", gap: "4px"}}>
                    <Button 
                        className="btn btn-lowercase" 
                        color="info">
                        {label}
                        {filteringApplied ? (
                            <span style={{height: "16px", lineHeight: "16px", fontSize: "10px", color: "white", backgroundColor: Theme.palette.error.main, padding: "0px 6px", borderRadius: "12px", fontWeight: 600}}>
                                {store.AutomationStore.searchStatuses?.length}
                            </span>
                        ) : null}
                    </Button>
                    <Icons.ChevronLeft style={{fontSize: "18px", transform: "rotateZ(-90deg)"}} />
                </div>
            )}>

            <ColumnHeaderStatusField options={options} />
        </InlineMenu>
    )
}


const ColumnHeaderStatusField = ({options}) => {

    const { searchStatuses, setSearchStatuses } = store.AutomationStore

    return (
        <div style={{padding: "10px", width: "300px"}}>
            <div className="form">
                <h3>Filter by Automation status</h3>
    
                <div style={{display: "grid", gap: "8px", maxHeight: "300px", overflowY: "auto", borderTop: "0.5px solid lightgrey", boxShadow: "#00000059 0px 14px 24px -16px inset", padding: "5px 0 0 5px"}}>
                    <Field.CheckboxSelect
                        formik 
                        value={searchStatuses}
                        options={DisplayDictionary("automation_status", true)}
                        warning={false}
                        onChange={(e) => setSearchStatuses(e.target.value)} />
                </div>

                <div style={{display: "flex", gap: "5px"}}>
                    <Button className="btn btn-sm" variant="contained" onClick={() => store.AutomationStore.setSearchStatuses([])}>Clear selection</Button>
                    <Button className="btn btn-sm" variant="contained" onClick={() => store.AutomationStore.setSearchStatuses(options.map(option => option.value))}>Select all</Button>
                </div>
            </div>
        </div>
    )
}